import type { ReactNode as Children } from 'react';
import { Typography } from '@mui/material';
import React from 'react';

import { Box } from '@mui/material';

interface SectionHeaderWithPreloaderProps {
    id?: string;
    title: string;
    subtitle?: Children;
    large?: boolean;
}

const SectionHeaderSmall = (
    props: SectionHeaderWithPreloaderProps
): JSX.Element => {
    const { title, subtitle, id, large } = props;

    return (
        <Box
            id={id}
            sx={{
                mb: 1,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Typography variant={large ? 'h3' : 'h5'}>{title}</Typography>
            </Box>
            {subtitle && (
                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                        mt: 0.5,
                    }}
                >
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
};

export default SectionHeaderSmall;
